import { request as sonataRequest } from 'sonata-react-components';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';

export function putUser(user: UserInterface, token: Record<string, any>): Promise<UserInterface> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}user/${user._id || user.id}`, {
    data: user,
    headers: {
      'sonata-origin': 'retail-api'
    },
    method: 'PUT',
    token
  });
}

export function postUserImage(
  userId: string,
  file: File,
  aspectRatio: number,
  token: Record<string, any>
): Promise<any> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}image/${userId}`, {
    data: file,
    headers: {
      'Content-Type': file.type,
      fileType: file.type
    },
    method: 'POST',
    params: {
      aspectRatio: aspectRatio || 0,
      name: encodeURIComponent(file.name)
    },
    token,
    transformRequest: [(data: any) => data]
  });
}
